module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-24.864f2ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-24.jpg
// module id = 3979
// module chunks = 14